import React from 'react';
import { ShowButton, DateInput, Datagrid, DateField, TextField, Filter, SelectInput, TextInput } from 'react-admin';
import TList from '../../components/wrapper/TList';
import { LinkField } from '../../components/fields';
import { toApiDateTimeFormat, toJavaScriptDateFormat } from '../../components/helper/DateHelper';
import { notificationTypesForSelection, notificationSubtypesForSelection } from './WalletNotificationConstants';
import WalletNotificationListActions from './WalletNotificationListActions';

const WalletNotificationFilter = ({ hideWalletIdFilter, ...props }) => (
	<Filter {...props}>
		{!hideWalletIdFilter &&
			<TextInput resettable label="resources.walletNotifications.filter.walletId" source="walletId" />
		}
		<TextInput
			resettable
			source="ownerType"
			label="resources.walletNotifications.filter.ownerType"
		/>
		<TextInput
			resettable
			source="ownerId"
			label="resources.walletNotifications.filter.ownerId"
		/>
		<TextInput
			resettable
			source="notifierType"
			label="resources.walletNotifications.filter.notifierType"
		/>
		<TextInput
			resettable
			source="notifierId"
			label="resources.walletNotifications.filter.notifierId"
		/>
		<TextInput
			resettable
			source="notificationComponent"
			label="resources.walletNotifications.filter.notificationComponent"
		/>
		<SelectInput
			resettable
			source="notificationType"
			label="resources.walletNotifications.filter.type"
			choices={notificationTypesForSelection}
		/>
		<SelectInput
			resettable
			source="notificationSubtype"
			label="resources.walletNotifications.filter.subType"
			choices={notificationSubtypesForSelection}
		/>
		<TextInput
			resettable
			label="resources.walletNotifications.filter.ipAddress"
			source="ipAddress"
		/>
		<DateInput
			resettable
			source="fromDate"
			label="resources.walletNotifications.filter.fromDate"
			parse={value => toApiDateTimeFormat(value)}
			format={value => toJavaScriptDateFormat(value)}

		/>
		<DateInput
			resettable
			source="untilDate"
			label="resources.walletNotifications.filter.untilDate"
			parse={value => toApiDateTimeFormat(value)}
			format={value => toJavaScriptDateFormat(value)}
		/>
	</Filter>
);

const WalletNotificationList = ({ hideWalletIdFilter, ...props }) => (
	<TList
		exporter={false}
		{...props}
		actions={<WalletNotificationListActions />}
		filters={<WalletNotificationFilter hideWalletIdFilter={hideWalletIdFilter} />}

	>
		<Datagrid >
			<ShowButton />
			{!hideWalletIdFilter &&
				<LinkField source="walletId" type="Wallet" sortable={false} />
			}
			<DateField source="creationDateTime" showTime sortable={false} />
			<LinkField source="owner" sortable={false} />
			<LinkField source="notifier" sortable={false} />
			<TextField source="notificationType" sortable={false} />
			<TextField source="notificationSubtype" sortable={false} />
			<TextField source="ipAddress" sortable={false} />
		</Datagrid>
	</TList>
);

export default WalletNotificationList;
